export default function camelCase(x: any): any {
  if (Array.isArray(x)) {
    return x.map(camelCase)
  }

  if (x && typeof x === 'object') {
    return Object.fromEntries(
      Object.entries(x).map(([k, v]) => [k.replaceAll(/_[a-z]/g, (r) => r[1].toUpperCase()), camelCase(v)])
    )
  }

  return x
}
